import "./index.css";

export function PrintContentMainTitle() {
  return (
    <div className="print-content-header">
      <b>해외주식 공시자료</b> 번역/요약본
    </div>
  );
}
